import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import NcHFLitesDetails from './NcHFLitesDetails';

const NcHFLitesModal = ({ selectedPayable, }) => {
  const [ show, setShow, ] = useState(false);

  return (
    <>
      <Button variant="primary" onClick={() => setShow(true)}>
        Details
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            Plate Number: {selectedPayable.plateNumber}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(() => {
            return show
              ? <NcHFLitesDetails selectedPayable={selectedPayable} />
              : undefined;
          })()}
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  );
};

export default NcHFLitesModal;

NcHFLitesModal.propTypes = {
  selectedPayable: PropTypes.instanceOf(Object).isRequired,
};
